"use strict";
exports.__esModule = true;
var SerializingLink_1 = require("./SerializingLink");
exports["default"] = SerializingLink_1["default"];
//# sourceMappingURL=index.js.map